module.exports = __webpack_public_path__ + "6713d665dc58cf4b495368a7871c133d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructors/images/icons/linkedin.svg
// module id = 32
// module chunks = 0 1